type TOrderOriginName = 'portal' | 'unknown'

type TOrderOrigin = {
  name: TOrderOriginName
  urlSegment: string
}

const origins: RoA<TOrderOrigin> = [
  {
    name: 'portal',
    urlSegment: 'dvz',
  },
]

export const useOrderOriginUrl = () => {
  const url = new window.URL(window.location.href)
  const pathSegments = url.pathname.split('/').filter(segment => segment !== '')

  const foundOrigin = origins.find(origin => {
    return pathSegments.includes(origin.urlSegment)
  })

  return foundOrigin?.name || 'unknown'
}
